import { ReactElement, PropsWithChildren } from 'react';
import { CircledQuestionMarkIcon } from '@primerai/icons';
import { VStack, Box, Link, Popover, Avatar } from '@primerai/thread';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'wouter';
import { ChatButton, useCustomerService } from '../customerService';
import {
  ButtonWrapper,
  Container,
  NavBar,
  Content,
  SecondaryActions,
  NAVBAR_ICON_SIZE,
} from './Authenticated.styles';
import { PrimerLogo } from './PrimerLogo';
import config from '~/config';
import { LOGOUT } from '~/routes/paths';
import { getCurrentUser } from '~/store/auth/selectors';

const HelpButton = (): ReactElement<unknown> | null => {
  if (!config.HELP_URL) {
    return null;
  }
  return (
    <ButtonWrapper>
      <Link href={config.HELP_URL} isExternal>
        <CircledQuestionMarkIcon
          color="$grayScale.g3"
          height={NAVBAR_ICON_SIZE}
          width={NAVBAR_ICON_SIZE}
        />
      </Link>
    </ButtonWrapper>
  );
};

const AccountButton = (): ReactElement<unknown> => {
  const user = useSelector(getCurrentUser);
  const username = user?.name ?? user?.username ?? '';
  return (
    <Popover.Root>
      <Popover.Trigger>
        <ButtonWrapper>
          <Avatar appearance="compact" corners="circular" username={username} />
        </ButtonWrapper>
      </Popover.Trigger>
      <Popover.Content align="end" p="$3" side="bottom">
        <VStack>
          <Link as={RouterLink} to={LOGOUT}>
            Log out
          </Link>
        </VStack>
      </Popover.Content>
    </Popover.Root>
  );
};

const AuthenticatedWrapper = ({
  children,
}: PropsWithChildren): ReactElement<unknown> => {
  useCustomerService();
  return (
    <Container>
      <NavBar>
        <Box py="$3">
          <PrimerLogo height={28} />
        </Box>
        <SecondaryActions>
          <ChatButton />
          <HelpButton />
          <AccountButton />
        </SecondaryActions>
      </NavBar>
      <Content>{children}</Content>
    </Container>
  );
};

export default AuthenticatedWrapper;
